import { render, staticRenderFns } from "./InteractConfig.vue?vue&type=template&id=03a50fec&scoped=true"
import script from "./InteractConfig.vue?vue&type=script&lang=js"
export * from "./InteractConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a50fec",
  null
  
)

export default component.exports